import { Map } from 'immutable';
import { call, fork, put, select, take, takeEvery } from 'redux-saga/effects';

import { interval } from 'helpers/saga';

import { SET_ACTIVE_ORDER, SET_ACTIVE_SPREAD } from 'redux/reducers/app';
import { addSpreadStat, fill } from 'redux/reducers/stats';
import { ADD_ORDER, save } from 'redux/reducers/orders';

import { getActiveOrderId, getActiveSpreadName } from 'redux/selectors/app';

const FORCE_SAVE_INTERVAL = 60;

/**
 * Mark spreads as seen when visiting it
 * @param spread
 */
export function* addSpreadStats({ spread }) {
  try {
    const orderId = yield select(state => getActiveOrderId(state));
    yield put(addSpreadStat(orderId, spread, 'last_seen', Math.round(Date.now() / 1000)));
  } catch (e) {
    pe(e);
  }
}

/**
 * Put order stats in it's own state
 * @param id
 */
export function* fillFromOrder({ id }) {
  try {
    const order = yield select(state => state.getIn(['orders', id], Map()));
    const orderStats = order.get('stats');

    if (orderStats) {
      yield put(fill(id, orderStats));
    }
  } catch (e) {
    pe(e);
  }
}

/**
 * Force save every minute
 */
function* forceSaveInterval() {
  const chan = yield call(interval, FORCE_SAVE_INTERVAL, false);

  while (true) {
    yield take(chan);

    try {
      yield put(save());
    } catch (e) {
      pe(e);
    }
  }
}

export default function* saga() {
  yield takeEvery(SET_ACTIVE_SPREAD, addSpreadStats);
  yield takeEvery(SET_ACTIVE_ORDER, fillFromOrder);
  yield takeEvery(ADD_ORDER, fillFromOrder);

  yield fork(forceSaveInterval);
}



// WEBPACK FOOTER //
// ./app/redux/sagas/stats.js